import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MergeConflictDialogComponent } from './merge-conflict-dialog.component';

@NgModule({
  declarations: [MergeConflictDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [MergeConflictDialogComponent],
  entryComponents: [MergeConflictDialogComponent],
})
export class MergeConflictDialogModule {}
